export default __webpack_public_path__ + "static/media/bhojpuri_af_1.94162dca.mp3";